import { useRef as u, useEffect as v, useState as p, useReducer as C } from "react";
import { useCallbackRef as ne, useMergeRefs as oe, useRefToCallback as se, useTransformRef as ue } from "use-callback-ref";
import { useCallbackOne as ae, useMemoOne as le } from "use-memo-one";
import { default as ie, useDeepCompareEffectNoCheck as de, useDeepCompareMemoize as pe } from "use-deep-compare-effect";
import m from "use-isomorphic-layout-effect";
import { default as be } from "use-isomorphic-layout-effect";
import { default as ge } from "use-composed-ref";
import { default as Ee } from "use-is-mounted-ref";
import O from "use-latest";
import { default as ye } from "use-latest";
import { useDebounce as Oe, useDebouncedCallback as ke, useThrottledCallback as Le } from "use-debounce";
const k = {}, L = [], d = L, w = (e) => {
  const t = u(!0), r = u();
  return t.current && (t.current = !1, r.current = e()), r.current;
}, q = (e) => {
  v(e, d);
}, x = (e) => {
  m(e, d);
}, P = (e) => {
  v(() => e, d);
}, z = (e) => {
  m(() => e, d);
}, D = (e) => {
  P(w(e));
}, b = (e) => {
  const t = new Event("change", { bubbles: !0 });
  return Object.defineProperty(t, "simulated", {
    enumerable: !0,
    value: !0
  }), e.dispatchEvent(t), !0;
}, T = (e, t) => {
  const r = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(e), "value");
  return r && r.set && r.set.call(e, t), b(e);
}, j = (e, t) => {
  const r = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(e), "checked");
  return r && r.set && r.set.call(e, t), b(e);
}, f = (e) => u(e).current, G = (e) => {
  const t = u(e);
  return t.current = e, f(function() {
    return Reflect.apply(t.current, this, arguments);
  });
}, g = () => {
}, E = () => {
  let e = !1, t = !1;
  if (!e)
    try {
      const r = Object.defineProperty({}, "passive", {
        enumerable: !0,
        get() {
          return t = !0, t;
        }
      });
      addEventListener("passive", g, r), removeEventListener("passive", g, r);
    } catch (r) {
      t = !1;
    } finally {
      e = !0;
    }
  return t ? { passive: t } : !1;
}, N = (e) => f(() => e.current !== null && b(e.current)), X = (e) => f((t) => e.current !== null && T(e.current, t)), Y = (e) => f((t) => e.current !== null && j(e.current, t)), J = (e, t, r) => {
  m(() => {
    const n = e.current;
    if (n === null)
      return;
    const o = E();
    return n.addEventListener(t, r, o), () => {
      n.removeEventListener(t, r, o);
    };
  }, [e.current]);
}, M = (e) => new Promise((t, r) => {
  const n = new Image();
  Object.assign(n, {
    src: e,
    crossOrigin: "Anonymous",
    loading: "eager",
    importance: "high",
    decoding: "async",
    onerror: () => r(new Error("Failed")),
    onabort: () => r(new Error("Aborted")),
    onload: () => t(n)
  });
}), S = (e) => new Promise((t, r) => {
  const n = new XMLHttpRequest();
  n.open("GET", e, !0), Object.assign(n, {
    responseType: "blob",
    onerror: () => r(new Error("Failed")),
    onabort: () => r(new Error("Aborted")),
    onload() {
      n.response ? t(n.response) : r(new Error("Failed"));
    }
  }), n.send();
}), h = (e) => {
  const [t, r] = p(!0), [n, o] = p(null), [i, s] = p(null);
  return D(() => {
    let c = !1;
    return r(!0), Promise.resolve().then(e).then((a) => {
      c || (r(!1), o(a));
    }, (a) => {
      c || (r(!1), s(a));
    }), () => {
      c = !0;
    };
  }), {
    pending: t,
    resolved: n,
    rejected: i
  };
}, K = (e) => h(() => M(e)), Q = (e) => h(() => S(e)), W = () => {
  const e = u(!0), t = u(!0);
  return t.current ? (t.current = !1, e) : t;
}, Z = (e) => {
  const t = u(e);
  return t.current = e, t;
}, _ = (e) => e, H = () => Math.max(
  window.pageYOffset,
  document.documentElement.scrollTop,
  document.body.scrollTop
), $ = (e) => {
  const t = O(e);
  x(() => {
    let r = !1;
    const n = () => {
      r && t.current(H());
    }, o = E();
    return addEventListener("scroll", n, o), () => {
      r = !1, removeEventListener("scroll", n, o);
    };
  });
}, I = () => ({}), U = () => C(I, k), F = () => U()[1], ee = (e) => {
  const t = u({}), r = u(e), n = F(), o = f((s) => {
    const c = typeof s == "function" ? s(r.current) : s, a = r.current, y = t.current;
    let R = !1;
    for (const l in c)
      a[l] !== c[l] && (a[l] = c[l], y[l] && (R = !0));
    R && n();
  }), i = {};
  for (const s in r.current)
    Object.defineProperty(i, s, {
      get() {
        return t.current[s] = !0, r.current[s];
      }
    });
  return [i, o];
};
export {
  ae as useCallbackOne,
  ne as useCallbackRef,
  N as useChangeCommit,
  Y as useCheckCommit,
  ge as useComposedRef,
  w as useCreation,
  Oe as useDebounce,
  ke as useDebouncedCallback,
  ie as useDeepCompareEffect,
  de as useDeepCompareEffectNoCheck,
  pe as useDeepCompareMemoize,
  W as useFirstRenderRef,
  f as useHandler,
  be as useIsomorphicLayoutEffect,
  ye as useLatestRef,
  x as useLayoutMount,
  z as useLayoutUnmount,
  Q as useLoadBlob,
  K as useLoadImage,
  le as useMemoOne,
  oe as useMergeRefs,
  q as useMount,
  Ee as useMountedRef,
  J as usePassiveEvent,
  h as usePromise,
  se as useRefToCallback,
  _ as useRender,
  D as useRenderEffect,
  $ as useScrollHandler,
  G as useStableHandler,
  Z as useStableRef,
  Le as useThrottledCallback,
  ee as useTrackState,
  ue as useTransformRef,
  P as useUnmount,
  F as useUpdate,
  U as useUpdateState,
  X as useValueCommit
};
